import colors from './styles/colors'
import { isProduction } from 'variables/environment'
import { BrandConfigType } from 'types'
import { getBrandDefaultFeatures } from 'brands'

const brand: BrandConfigType = {
  liffID: {
    home: isProduction ? '1657194971-5LrJ3L3Y' : '1657195050-n1ZJmKBE',
    hatoheart: isProduction ? '1657194971-4LAJWMWE' : '',
    lineID: isProduction ? '@zwh6059z' : '@439bwrsu',
  },
  id: isProduction ? 70 : 181,
  title: 'ฮั่วเซ่งฮง ภัตตาคาร',
  label: 'ฮั่วเซ่งฮง ภัตตาคาร',
  slug: 'huasenghong',
  slogan: '',
  favIcon: `${process.env.PUBLIC_URL}/assets/fav-indydish.png`,
  brandSelectImg: '',
  theme: {
    ui: 'generic',
    colors,
  },
  omisePublicKey: isProduction ? 'pkey_5spqkdvinnbxawewjn3' : 'pkey_test_54yhq808rsaoya3zpmr',
  companyName: 'บริษัท ฮั่วเซ่งฮงราชพฤกษ์ จำกัด',
  contactNumber: '063-059-0999',
  contactPolicy: 'Marketing@huasenghong.co.th', // Email or Phone Number
  features: getBrandDefaultFeatures(),
}

export default brand
